import { TranslationType } from '../../../model';

export class ToggleTableFilterVisibility {
  static readonly type = '[Table Filter] Toggle Table Filter Visibility';
}

export class SetTableFilterValue {
  static readonly type = '[Table Filter] Set Table Filter Value';
  constructor(public payload: TranslationType) {}
}
